/* eslint-disable no-console */
import FingerprintJS, { type Agent, type GetResult } from '@fingerprintjs/fingerprintjs'

let fpPromise: Promise<Agent | null> | null = null

const sanitizeFingerprint = (fingerprint: any) => {
  if (!fingerprint || typeof fingerprint !== 'object') return fingerprint

  const { components } = fingerprint
  if (!components || typeof components !== 'object') return fingerprint

  const safeComponents = { ...components }
  delete safeComponents.webGlExtensions
  delete safeComponents.canvas
  delete safeComponents.math

  return {
    ...fingerprint,
    components: safeComponents
  }
}

export async function getFingerprint(): Promise<GetResult | null> {
  if (typeof window === 'undefined') return null

  if (!fpPromise) {
    fpPromise = FingerprintJS.load().catch(error => {
      console.error('Error loading FingerprintJS:', error)
      return null
    })
  }

  try {
    const fp = await fpPromise
    if (!fp) return null
    const fingerprint = await fp.get()
    return sanitizeFingerprint(fingerprint)
  } catch (error) {
    console.error('Error fetching FingerprintJS', error)
    return null
  }
}
